import {
  USER_GROUP_PATCH_DIALOG_RECEIVE,
  USER_GROUP_PATCH_DIALOG_FAILURE } from './user'

export const ADD_TO_SELECTED = 'tableDialog/ADD_TO_SELECTED'
export const RESET_DIALOG = 'tableDialog/RESET_DIALOG'
export const OPEN_DIALOG = 'tableDialog/OPEN_DIALOG'

const initialState = {
  selected: [],
  showTableDialog: false,
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_TO_SELECTED:
      return {
        ...state,
        selected: [...action.payload]
      }
    case RESET_DIALOG:
      return {
        ...state,
        selected: [],
        showTableDialog: false
      }
    case USER_GROUP_PATCH_DIALOG_RECEIVE:
      return {
        ...state,
        showTableDialog: false
      }
    case USER_GROUP_PATCH_DIALOG_FAILURE:
      return {
        ...state,
        showTableDialog: false
      }
    case OPEN_DIALOG:
      return {
        ...state,
        showTableDialog: true
      }
    default:
      return state
  }
}

export const addToSelected = (payload) => ({ type: ADD_TO_SELECTED, payload})

export const openDialog = () => ({ type: OPEN_DIALOG })

export const resetDialog = () => ({ type: RESET_DIALOG })

export default reducer
